import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "panel", "search", "hidden", "label", "labelFlagImage", "labelName", "option", "clear", "list"]

  connect() {
    this.boundOutsideClick = this.handleOutsideClick.bind(this)
    document.addEventListener("click", this.boundOutsideClick)
    this.sync()
  }

  disconnect() {
    document.removeEventListener("click", this.boundOutsideClick)
  }

  toggle(event) {
    event.preventDefault()
    this.panelTarget.hidden = !this.panelTarget.hidden

    if (!this.panelTarget.hidden) {
      this.searchTarget.value = ""
      this.filter()
      this.searchTarget.focus()
    }
  }

  select(event) {
    event.preventDefault()

    const option = event.currentTarget
    this.hiddenTarget.value = option.dataset.countryCode
    this.searchTarget.value = ""
    this.panelTarget.hidden = true
    this.sync()
  }

  clear(event) {
    event.preventDefault()

    this.hiddenTarget.value = ""
    this.searchTarget.value = ""
    this.panelTarget.hidden = true
    this.sync()
  }

  filter() {
    const query = this.searchTarget.value.trim().toLowerCase()

    this.optionTargets.forEach((option) => {
      const name = option.dataset.countryName.toLowerCase()
      const code = option.dataset.countryCode.toLowerCase()
      const matches = query.length === 0 || name.includes(query) || code.includes(query)

      option.hidden = !matches
      option.style.display = matches ? "flex" : "none"
    })

    if (this.hasListTarget) {
      this.listTarget.scrollTop = 0
    }
  }

  sync() {
    const activeOption = this.optionTargets.find((option) => option.dataset.countryCode === this.hiddenTarget.value)

    this.optionTargets.forEach((option) => {
      const active = option === activeOption
      option.dataset.active = active ? "true" : "false"
      option.setAttribute("aria-selected", active ? "true" : "false")
    })

    if (activeOption) {
      if (this.hasLabelFlagImageTarget) {
        this.labelFlagImageTarget.src = activeOption.dataset.countryFlagPath
        this.labelFlagImageTarget.hidden = false
      }
      if (this.hasLabelNameTarget) {
        this.labelNameTarget.textContent = activeOption.dataset.countryName
      } else {
        this.labelTarget.textContent = activeOption.dataset.countryLabel
      }
      this.clearTarget.hidden = false
    } else {
      if (this.hasLabelFlagImageTarget) {
        this.labelFlagImageTarget.removeAttribute("src")
        this.labelFlagImageTarget.hidden = true
      }
      if (this.hasLabelNameTarget) {
        this.labelNameTarget.textContent = "Choose country"
      } else {
        this.labelTarget.textContent = "Choose country"
      }
      this.clearTarget.hidden = true
    }

    this.filter()
  }

  handleOutsideClick(event) {
    if (this.element.contains(event.target)) return
    if (!this.hasPanelTarget) return

    this.panelTarget.hidden = true
  }
}
